import React, { useState } from 'react';
import { Upload, X } from 'lucide-react';
interface ImageUploadProps {
  label?: string;
  currentImage?: string;
  onImageChange: (imageUrl: string) => void;
  onImageRemove?: () => void;
  helperText?: string;
}
const ImageUpload: React.FC<ImageUploadProps> = ({
  label = 'Immagine',
  currentImage,
  onImageChange,
  onImageRemove,
  helperText
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Create preview URL
      const previewUrl = URL.createObjectURL(file);
      onImageChange(previewUrl);
    }
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file && file.type.startsWith('image/')) {
      const previewUrl = URL.createObjectURL(file);
      onImageChange(previewUrl);
    }
  };
  const handleRemove = () => {
    if (onImageRemove) {
      onImageRemove();
    } else {
      onImageChange('');
    }
  };
  return <div data-id="element-1214">
      {label && <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1215">
          {label}
        </label>}

      {currentImage ? <div className="relative" data-id="element-1216">
          <img src={currentImage} alt="Preview" className="w-full h-48 object-cover rounded-lg border border-gray-300" data-id="element-1217" />
          <button type="button" onClick={handleRemove} className="absolute top-2 right-2 p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors" data-id="element-1218">
            <X className="h-4 w-4 text-gray-600" data-id="element-1219" />
          </button>
        </div> : <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${isDragging ? 'border-green-600 bg-green-50' : 'border-gray-300 hover:bg-gray-50'}`} data-id="element-1220">
          <input type="file" accept="image/*" onChange={handleFileChange} className="hidden" id="image-upload" data-id="element-1221" />
          <label htmlFor="image-upload" className="cursor-pointer" data-id="element-1222">
            <Upload className="h-10 w-10 text-gray-400 mx-auto mb-3" data-id="element-1223" />
            <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-1224">
              Clicca per caricare o trascina qui
            </p>
            <p className="text-xs text-gray-500" data-id="element-1225">PNG, JPG, GIF fino a 10MB</p>
          </label>
        </div>}

      {helperText && <p className="mt-2 text-sm text-gray-500" data-id="element-1226">{helperText}</p>}
    </div>;
};
export default ImageUpload;